export const ALPHABET: string[] = Array.from({
  length: 'Z'.charCodeAt(0) - 'A'.charCodeAt(0) + 1,
}).map((_, index) => String.fromCharCode('A'.charCodeAt(0) + index));
